var _rect, _g, _g2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwitchDeviceGeneric(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 241.37,
    height: 62.75,
    viewBox: "0 0 241.37 62.75",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 225.37,
    height: 59.75,
    rx: 10.5,
    fill: "#FFFFFF",
    stroke: "#E0E0F0",
    strokeWidth: 3,
    strokeDasharray: "17 10",
    strokeLinecap: "butt"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(200.9 8.6) scale(0.48)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 19.9087C0 19.9087 12.4054 20.4086 19.5169 18.2728C21.221 17.773 22.3343 17.2504 23.0159 16.8187C23.1522 16.7278 23.2885 16.637 23.4021 16.5688C23.5157 16.5006 23.6066 16.4098 23.6748 16.3416C23.7884 16.2507 23.8793 16.1598 23.9474 16.0917C24.0383 15.9781 24.1065 15.9099 24.1519 15.8417C24.1746 15.819 24.1746 15.7963 24.1973 15.7736C24.2201 15.7509 24.2201 15.7281 24.2201 15.7281L25.0834 10.8887C25.0834 10.8887 24.3109 11.9793 20.3803 13.4334C13.0189 16.1144 0.704336 15.9099 0.704336 15.9099L0 19.9087Z",
    fill: "#C0CCDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9692 0.0508145C26.9692 0.0508145 14.5638 -0.449037 7.45227 1.68669C5.74823 2.18654 4.63492 2.70911 3.95331 3.1408C3.81699 3.23169 3.68066 3.32257 3.56706 3.39073C3.45346 3.45889 3.36258 3.54977 3.29441 3.61794C3.18081 3.70882 3.08993 3.7997 3.02177 3.86786C2.93089 3.98146 2.86272 4.04963 2.81728 4.11779C2.79456 4.14051 2.79456 4.16323 2.77184 4.18595C2.74912 4.20867 2.74912 4.23139 2.74912 4.23139L1.88574 9.07086C1.88574 9.07086 2.65824 7.98027 6.58889 6.52616C13.9503 3.84514 26.2649 4.04963 26.2649 4.04963L26.9692 0.0508145Z",
    fill: "#C0CCDA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06738 9.66147C2.0901 10.2068 2.36275 11.161 4.02135 12.0017C6.49788 13.2513 13.0641 13.3422 17.6309 13.7057C18.1762 13.6148 19.5395 13.2059 20.1075 13.0014C23.2429 11.8654 24.4471 10.8657 24.7879 10.4794C24.5834 10.1159 24.1063 9.27522 21.1072 8.88897C17.2901 8.38912 8.58817 8.38912 5.70267 7.3667C3.15797 8.43456 2.24915 9.41155 2.06738 9.66147Z",
    fill: "#DFE8F1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.5 18.7) scale(0.595)",
    stroke: "#CBD5E1",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 3.5,
    width: 329,
    height: 49,
    rx: 2.5,
    fill: "#FFFFFF",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 12.5,
    width: 31.5,
    height: 31,
    rx: 1.5,
    fill: "none",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.5,
    y: 19.5,
    width: 150.5,
    height: 15,
    rx: 1.5,
    fill: "none",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.5,
    y: 24.5,
    width: 7,
    height: 6,
    fill: "none",
    strokeWidth: 1.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.5,
    y: 24.5,
    width: 7,
    height: 6,
    fill: "none",
    strokeWidth: 1.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.5,
    y: 24.5,
    width: 7,
    height: 6,
    fill: "none",
    strokeWidth: 1.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 122.5,
    y: 24.5,
    width: 7,
    height: 6,
    fill: "none",
    strokeWidth: 1.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.5,
    y: 24.5,
    width: 7,
    height: 6,
    fill: "none",
    strokeWidth: 1.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.5,
    y: 24.5,
    width: 7,
    height: 6,
    fill: "none",
    strokeWidth: 1.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.5,
    y: 24.5,
    width: 7,
    height: 6,
    fill: "none",
    strokeWidth: 1.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.5,
    y: 24.5,
    width: 7,
    height: 6,
    fill: "none",
    strokeWidth: 1.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.5,
    y: 24.5,
    width: 7,
    height: 6,
    fill: "none",
    strokeWidth: 1.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.5,
    y: 24.5,
    width: 7,
    height: 6,
    fill: "none",
    strokeWidth: 1.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.5,
    y: 18.5,
    width: 19,
    height: 17,
    rx: 1.5,
    fill: "none",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 249.5,
    y1: 26.5,
    x2: 268.5,
    y2: 26.5,
    strokeWidth: 1.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.5,
    y: 18.5,
    width: 19,
    height: 17,
    rx: 1.5,
    fill: "none",
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("line", {
    x1: 279.5,
    y1: 26.5,
    x2: 298.5,
    y2: 26.5,
    strokeWidth: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314.5,
    cy: 27.5,
    r: 3,
    fill: "none",
    strokeWidth: 1.15
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchDeviceGeneric);
export default __webpack_public_path__ + "static/media/switch-device-generic.3f45faab41f950d1e74c970d7cc58aa7.svg";
export { ForwardRef as ReactComponent };